
 /**
 * Textarea auto reszie
 */

export default function textareaResize() {

  const textarea = document.getElementsByTagName('textarea');

  // When textarea exists
  if (textarea.length > 0) {
  
    for (var i = 0; i < textarea.length; i++) {
      textarea[i].setAttribute('style', 'height:' + (textarea[i].scrollHeight) + 'px;overflow-y:hidden;');
      textarea[i].addEventListener("input", OnInput, false);
    }
  }

  function OnInput() {
    this.style.height = 'auto';
    this.style.height = (this.scrollHeight) + 'px';
  }
}